import React, { createContext, useContext, useEffect, useState } from 'react';
import { getOEMRegionList } from '../libs/db-lib';
import { useUser } from './User';

export interface OemRegionContextInterface {
  oemInfo: { [key: string]: string };
  oemRegionList: any[];
}

export const OemRegionContext = createContext<OemRegionContextInterface>({
  oemInfo: {},
  oemRegionList: [],
});

export const useOemRegion = () => {
  return useContext(OemRegionContext);
};

type OemRegionProviderType = {
  children: JSX.Element;
};

export function OemRegionProvider({ children }: OemRegionProviderType) {
  const { user } = useUser();

  const [oemInfo, setOemInfo] = useState<{ [key: string]: string }>({});
  const [oemRegionList, setOemRegionList] = useState<any[]>([]);

  useEffect(() => {
    const fetchOemInfo = async () => {
      const fetchedOemRegionList = await getOEMRegionList();
      const oemInfoAux: { [key: string]: string } = {};
      if (!fetchedOemRegionList.error) {
        fetchedOemRegionList.forEach((element: any) => {
          oemInfoAux[element.oemID] = element.oemName;
          oemInfoAux[element.regionCode] = element.regionName;
        });
        setOemInfo(oemInfoAux);
        setOemRegionList(fetchedOemRegionList);
      }
    };

    if (user) {
      fetchOemInfo();
    }
  }, [user]);

  const provider = { oemInfo, oemRegionList };

  return (
    <OemRegionContext.Provider value={provider}>
      {children}
    </OemRegionContext.Provider>
  );
}
